(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('zeta', {
            parent: 'entity',
            url: '/zeta',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.zeta.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zeta/zetas.html',
                    controller: 'ZetaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zeta');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('zeta-detail', {
            parent: 'zeta',
            url: '/zeta/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.zeta.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zeta/zeta-detail.html',
                    controller: 'ZetaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zeta');
					$translatePartialLoader.addPart('venta'); 
					$translatePartialLoader.addPart('ticket'); 
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Zeta', function($stateParams, Zeta) {
                    return Zeta.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'zeta',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('zeta-detail.edit', {
            parent: 'zeta-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zeta/zeta-dialog.html',
                    controller: 'ZetaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zeta', function(Zeta) {
                            return Zeta.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zeta.new', {
            parent: 'zeta',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zeta/zeta-dialog.html',
                    controller: 'ZetaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                comercio: null,
                                nropv: null,
                                fechadesde: null,
                                fechahasta: null,
                                ticketsmontoventas: null,
                                ticketsmontoncredito: null,
                                ticketscantventas: null,
                                ticketscantncredito: null,
                                itemscantventas: null,
                                itemscantncredito: null,
                                ip: null,
                                nroz: null,
                                fechaoperativa: null,
                                totalefectivo: null,
                                totaltarjeta: null,
                                id: null,
								aeropuerto: null,
								metodo: null,
								modimpresora: null,
								tax1a: null,
								razonsocial: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('zeta', null, { reload: 'zeta' });
                }, function() {
                    $state.go('zeta');
                });
            }]
        })
        .state('zeta.edit', {
            parent: 'zeta',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zeta/zeta-dialog.html',
                    controller: 'ZetaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zeta', function(Zeta) {
                            return Zeta.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zeta', null, { reload: 'zeta' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zeta.delete', {
            parent: 'zeta',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zeta/zeta-delete-dialog.html',
                    controller: 'ZetaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Zeta', function(Zeta) {
                            return Zeta.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zeta', null, { reload: 'zeta' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
